import React from "react";
import {Checkbox, FormControl, InputLabel, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent} from "@mui/material";

const LANGUAGE_OPTIONS = [
	{value: "en", label: "English"},
	{value: "es-419", label: "Spanish"}
] as const;

export const AdminTableLanguagesFilterSelect = (props: any): JSX.Element => {
	const selected = Array.isArray(props.item.value) ? props.item.value : props.item.value ? [props.item.value] : [];

	const handleChange = (event: SelectChangeEvent<string[]>) => {
		const value = event.target.value;
		const next = typeof value === "string" ? value.split(",") : value;
		props.applyValue({...props.item, value: next});
	};

	return (
		<FormControl variant="standard" size="small" fullWidth>
			<InputLabel id="languages-filter-label">Value</InputLabel>
			<Select
				labelId="languages-filter-label"
				multiple
				value={selected}
				onChange={handleChange}
				renderValue={(v) => (Array.isArray(v) ? v.map((code) => LANGUAGE_OPTIONS.find((o) => o.value === code)?.label ?? code).join(", ") : "")}
				label="Value"
			>
				{LANGUAGE_OPTIONS.map((opt) => (
					<MenuItem key={opt.value} value={opt.value}>
						<ListItemIcon>
							<Checkbox checked={selected.indexOf(opt.value) > -1} size="small" />
						</ListItemIcon>
						<ListItemText primary={opt.label} />
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
